import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Entitlements } from '@models';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LoggerService } from '../logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class EntitlementsService {
  private http: HttpClient = inject(HttpClient);
  private logger = inject(LoggerService).setContext('EntitlementsService');

  getUserEntitlements(): Observable<Entitlements> {
    const ENTITLEMENTS_URL = environment.ENTITLEMENTS_URL;

    return this.http
      .get<Entitlements>(ENTITLEMENTS_URL, {
        observe: 'response',
        withCredentials: true
      })
      .pipe(
        map((response) => response.body as Entitlements),
        catchError((error: HttpErrorResponse) => {
          this.logger.error('Error fetching user entitlements:', error);
          return throwError(() => error);
        })
      );
  }
}
